const STATE_LABEL = {
    attention: "Attention needed",
    synced: "Synced",
    syncing: "Syncing",
};
const STATE_BADGE_CLASS = {
    attention: "node-badge-offline",
    synced: "node-badge-connected",
    syncing: "node-badge-neutral",
};
/**
 * RPC-backed ambient sync glyph — an at-a-glance idle/syncing/attention state. It
 * deliberately does not duplicate `<node-sync-center>`'s "N pending · N conflicts" counts;
 * that remains the sync center's job.
 */
export class NodeSyncIndicatorElement extends HTMLElement {
    #client;
    #records = [];
    #unsubscribe;
    connectedCallback() { this.render(); this.#subscribe(); }
    disconnectedCallback() { this.#unsubscribe?.(); this.#unsubscribe = undefined; }
    set client(value) {
        this.#client = value;
        this.#unsubscribe?.();
        this.#unsubscribe = undefined;
        if (this.isConnected)
            this.#subscribe();
    }
    get client() { return this.#client; }
    render() {
        const state = this.#deriveState();
        this.innerHTML = `<span class="node-badge ${STATE_BADGE_CLASS[state]}" aria-live="polite">${STATE_LABEL[state]}</span>`;
    }
    #deriveState() {
        if (this.#records.some((record) => record.state === "conflict" || record.state === "failed"))
            return "attention";
        if (this.#records.some((record) => record.state === "pending" || record.state === "replaying"))
            return "syncing";
        return "synced";
    }
    #subscribe() {
        if (!this.#client || this.#unsubscribe !== undefined)
            return;
        this.#unsubscribe = this.#client.liveQuery("sync.outbox-status.v1", {}, (diff) => {
            const records = new Map(this.#records.map((record) => [record.id, record]));
            for (const record of diff.deleted)
                records.delete(record.id);
            for (const record of [...diff.added, ...diff.updated])
                records.set(record.id, record);
            this.#records = [...records.values()].sort((left, right) => left.createdAt.localeCompare(right.createdAt));
            this.render();
        });
    }
}
//# sourceMappingURL=sync-indicator.js.map